import { MrModalDialog } from '@mrhenry/wp--mr-interactive';
import { MrVideo } from './mr-video';

class MrVideoOverlay extends MrModalDialog {
	override async willOpen() {
		await super.willOpen();
		document.body.classList.add( 'is-showing-modal-dialog' );
		document.documentElement.classList.add( 'is-showing-modal-dialog' );

		const mrVideo = this.querySelector<MrVideo>( 'mr-video' );
		if ( !mrVideo ) {
			return;
		}

		mrVideo.setupVideoPlayback();
	}

	override async didOpen(): Promise<void> {
		await super.didOpen();

		const mrVideo = this.querySelector<MrVideo>( 'mr-video' );
		if ( !mrVideo ) {
			return;
		}

		await mrVideo.play();
	}

	override async willClose() {
		const mrVideo = this.querySelector<MrVideo>( 'mr-video' );
		if ( !mrVideo ) {
			return;
		}

		await mrVideo.pause();
		await super.willClose();
		document.body.classList.remove( 'is-showing-modal-dialog' );
		document.documentElement.classList.remove( 'is-showing-modal-dialog' );
	}

	override openAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this,
				[
					{
						opacity: '0',
					},
					{
						opacity: '1',
					},
				],
				{
					duration: 512,
					easing: 'linear',
					fill: 'forwards',
				}
			),
			new KeyframeEffect(
				this.querySelector( '.video-overlay__media__player' ),
				[
					{
						opacity: '0',
						scale: 1.05,
					},
					{
						opacity: '1',
						scale: 1,
					},
				],
				{
					duration: 704,
					easing: 'ease-in-out',
					fill: 'forwards',
					delay: 512,
				}
			),
		];
	}

	override closeAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this.querySelector( '.video-overlay__media__player' ),
				[
					{
						opacity: '1',
						scale: 1,
					},
					{
						opacity: '0',
						scale: 1.05,
					},
				],
				{
					duration: 256,
					easing: 'ease-in-out',
					fill: 'forwards',
				}
			),
			new KeyframeEffect(
				this,
				[
					{
						opacity: '1',
					},
					{
						opacity: '0',
					},
				],
				{
					duration: 256,
					easing: 'linear',
					fill: 'forwards',
					delay: 128,
				}
			),

		];
	}
}

customElements.define( 'mr-video-overlay', MrVideoOverlay );
